import { Box, Button, Typography } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";

interface ContributeChemaBarProps {
  onContribute: () => void;
}

export default function ContributeChemaBar({
  onContribute,
}: ContributeChemaBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        bgcolor: "#155f52",
        px: 2,
        py: 1.25,
        borderRadius: "0 0 20px 20px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            bgcolor: "rgba(255,255,255,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <FavoriteIcon sx={{ color: "#fff", fontSize: 18 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.9rem",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Chema Family Fund Active
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.7)",
              fontSize: "0.7rem",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Secure donations for the family
          </Typography>
        </Box>
      </Box>

      <Button
        onClick={onContribute}
        sx={{
          bgcolor: "#fff",
          color: "#155f52",
          borderRadius: "999px",
          textTransform: "uppercase",
          fontWeight: 700,
          fontSize: "0.75rem",
          letterSpacing: 0.5,
          px: 2.5,
          py: 1,
          flexShrink: 0,
          "&:hover": { bgcolor: "rgba(255,255,255,0.85)" },
        }}
      >
        Contribute Chema
      </Button>
    </Box>
  );
}
